import type { JSX, ReactNode } from 'react';

import { cn } from '../lib/cn';

export interface SidebarGroupProps {
  label: string;
  /** The `<li>` items of the group; the caller assembles them. */
  children: ReactNode;
  className?: string;
}

/** Purely visual grouping \u2014 no expand/collapse state (design.md, decision #1). */
export function SidebarGroup({ label, children, className }: SidebarGroupProps): JSX.Element {
  return (
    <div className={className}>
      <h3 className={cn('text-xs uppercase text-slate-400')}>{label}</h3>
      <ul>{children}</ul>
    </div>
  );
}
